import "littlefoot/dist/littlefoot.css";
import "vite/modulepreload-polyfill";

import littlefoot from "littlefoot";
littlefoot();
